import Chart from 'components/assets/depreciation/AssetsDepreciationChart';
import Detail from 'components/assets/depreciation/AssetsDepreciationDetail';
import EndDate from 'components/assets/depreciation/AssetsDepreciationEndDate';
import Info from 'components/assets/depreciation/AssetsDepreciationInfo';
import Fail from 'components/assets/depreciation/AssetsDepreciationFail';
import Values from 'components/assets/depreciation/AssetsDepreciationValues';

export default { Chart, Detail, EndDate, Info, Fail, Values };



// WEBPACK FOOTER //
// src/components/assets/depreciation/index.js